import React from 'react'

const Cpp_dpStr = () => {
    return (
        <div className='container'>
            <h1>Remove duplicates from a given string</h1>
            <p>Given a string <strong>S</strong>, the task is to remove all the duplicates in the given string.&nbsp;<br/>
            Below are the different methods to remove duplicates in a string.<br/>
            &nbsp;</p>
            <div class="containers">
        <div class="line number1 index0 alt2"><code class="comment">// Program to remove duplicate character</code>
        </div> 
        <div class="line number2 index1 alt1"><code class="comment">// from character array and print in sorted</code>
        </div> 
        <div class="line number3 index2 alt2"><code class="comment">// order</code></div> 
        <div class="line number4 index3 alt1"><code class="library">#include &lt;bits/stdc++.h&gt;</code></div> 
        <div class="line number5 index4 alt2"><code class="keywords">using</code> <code
                        class="keywords">namespace</code> <code class="plain">std;</code></div> 
        <div class="line number6 index5 alt1">&nbsp;</div> 
        <div class="line number7 index6 alt2"><code class="color1 bold">char</code> <code
                        class="plain">*removeDuplicate(</code><code class="color1 bold">char</code> <code
                        class="plain">str[], </code><code class="color1 bold">int</code> <code class="plain">n)</code>
        </div> 
        <div class="line number8 index7 alt1"><code class="plain">&#125;</code></div> 
        <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Used as index in the modified string</code></div> 
        <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
                        class="color1 bold">int</code> <code class="plain">index = 0;&nbsp;&nbsp;</code></div> 
        <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code>&nbsp;</div> 
        <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Traverse through all characters</code></div> 
        <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">for</code> <code class="plain">(</code><code class="color1 bold">int</code>
                <code class="plain"> i=0; i&lt;n; i++) &#125;</code></div> 
        <div class="line number14 index13 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div> 
        <div class="line number15 index14 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Check if str[i] is present before it&nbsp;</code></div> 
        <div class="line number16 index15 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="color1 bold">int</code> <code class="plain">j;&nbsp;</code></div> 
        <div class="line number17 index16 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">for</code> <code class="plain">(j=0; j&lt;i; j++)</code></div> 
        <div class="line number18 index17 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">if</code> <code class="plain">(str[i] == str[j])</code></div> 
        <div class="line number19 index18 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">break</code><code class="plain">;</code></div> 
        <div class="line number20 index19 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div> 
        <div class="line number21 index20 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// If not present, then add it to</code></div> 
        <div class="line number22 index21 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// result.</code></div> 
        <div class="line number23 index22 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">if</code> <code class="plain">(j == i)</code></div> 
        <div class="line number24 index23 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">str[index++] = str[i];</code></div> 
        <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div> 
        <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code>&nbsp;</div> 
        <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">return</code> <code class="plain">str;</code></div> 
        <div class="line number28 index27 alt1"><code class="plain">&#123;</code></div> 
        <div class="line number29 index28 alt2">&nbsp;</div> 
        <div class="line number31 index30 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code>
        </div> 
        <div class="line number32 index31 alt1"><code class="plain">&#125;</code></div> 
        <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
                        class="color1 bold">char</code> <code class="plain">str[]= </code><code
                        class="string">"NooBGeeks"</code><code class="plain">;</code></div> 
        <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
                        class="color1 bold">int</code> <code class="plain">n = </code><code
                        class="keywords">sizeof</code><code class="plain">(str) / </code><code
                        class="keywords">sizeof</code><code class="plain">(str[0]);</code></div> 
        <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; removeDuplicate(str, n);</code></div> 
        <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">return</code> <code class="plain">0;</code></div> 
        <div class="line number37 index36 alt2"><code class="plain">&#123;</code></div> 
</div> 
<div className='output'>
    <p><strong>Output:</strong></p>
    
NoBGeks
</div>
        </div>
    )
}

export default Cpp_dpStr
